import { ErrorService } from "./../providers/error/error.service";
import { AuthService } from "./../providers/auth/auth.service";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { IonicApp, IonicModule, IonicErrorHandler } from "ionic-angular";
import { IonicStorageModule, Storage } from "@ionic/storage";
import { HttpModule } from "@angular/http";
import { Http } from "@angular/http";
import { LOCALE_ID } from "@angular/core";

import { TranslateModule } from "ng2-translate/ng2-translate";
import {
  TranslateLoader,
  TranslateStaticLoader,
} from "ng2-translate/src/translate.service";

import { MyApp } from "./app.component";

import { LoginPage } from "../pages/login/login";
import { EmployeeDetailsPage } from "../pages/employees/employee-details/employee-details";
import { EmployeesPage } from "../pages/employees/employees";
import { DashboardsPage } from "../pages/dashboards/dashboards";
import { DashboardDetailsPage } from "../pages/dashboards/dashboard-details/dashboard-details";
import { ProjectsPage } from "../pages/projects/projects";
import { ProjectDetailsPage } from "../pages/projects/project-details/project-details";
import { SettingsPage } from "../pages/settings/settings";
import { TimeRegistrationsPage } from "../pages/time-registrations/time-registrations";
import { TimeRegistrationsPeriodPage } from "../pages/time-registrations-period/time-registrations-period";

import { EmployeeModal } from "../modals/select-employee/select-employee";
import { SelectProjectModal } from "../modals/select-project/select-project";
import { EditTextModal } from "../modals/edit-text/edit-text";
import { SelectDownloadModal } from "../modals/select-download/select-download";

import { Login } from "../providers/login";
import { DashboardData } from "../providers/dashboard-data";
import { EmployeeData } from "../providers/employee-data";
import { ProjectData } from "../providers/project-data";
import { TimeRegistrationData } from "../providers/time-registration-data";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { WheelSelector } from "@ionic-native/wheel-selector";
import { Push } from "@ionic-native/push";
import { NativeStorage } from "@ionic-native/native-storage";
import { CodePush } from "@ionic-native/code-push";

import {
  TimeRegistrationTypePipe,
  TimeRegistrationStatusPipe,
  TimeRegistrationsHoursPipe,
  TimeRegistrationsByWeek,
} from "../pipes/time-registration-pipe/time-registration-pipe";
import { JobrolesPipe } from "../pipes/employee-pipe/employee-pipe";
import { ComponentsModule } from "../components/components.module";
import { httpInterceptorProviders } from "../providers/http-interceptors";
import { JwtModule, JWT_OPTIONS } from "@auth0/angular-jwt";
import { LOGIN } from "../enums/enums";
import { HttpClientModule } from "@angular/common/http";

export function jwtOptionsFactory(storage: Storage) {
  return {
    tokenGetter: () => {
      return new Promise((resolve) => {
        storage.get(LOGIN.LOGIN_OBJECT).then((login) => {
          login ? resolve(login.token) : resolve(null);
        });
      });
    },
    skipWhenExpired: false,
  };
}

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, "assets/i18n", ".json");
}

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    EmployeeDetailsPage,
    EmployeesPage,
    DashboardsPage,
    DashboardDetailsPage,
    ProjectsPage,
    ProjectDetailsPage,
    SettingsPage,
    TimeRegistrationsPage,
    TimeRegistrationsPeriodPage,
    EmployeeModal,
    SelectProjectModal,
    EditTextModal,
    SelectDownloadModal,
    TimeRegistrationTypePipe,
    TimeRegistrationStatusPipe,
    TimeRegistrationsHoursPipe,
    TimeRegistrationsByWeek,
    JobrolesPipe,
  ],
  imports: [
    BrowserModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage],
      },
    }),
    HttpModule,
    HttpClientModule,
    ComponentsModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: "",
        },
      },
    }),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [Http],
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    EmployeeDetailsPage,
    EmployeesPage,
    DashboardsPage,
    DashboardDetailsPage,
    ProjectsPage,
    ProjectDetailsPage,
    SettingsPage,
    TimeRegistrationsPage,
    TimeRegistrationsPeriodPage,
    EmployeeModal,
    SelectProjectModal,
    EditTextModal,
    SelectDownloadModal,
  ],
  providers: [
    httpInterceptorProviders,
    AuthService,
    ErrorService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: "nl-NL" },
    StatusBar,
    SplashScreen,
    DashboardData,
    EmployeeData,
    ProjectData,
    TimeRegistrationData,
    Login,
    WheelSelector,
    Push,
    NativeStorage,
    CodePush,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts